import { render, staticRenderFns } from "./SustentabilitySection.vue?vue&type=template&id=5490df68&scoped=true"
import script from "./SustentabilitySection.vue?vue&type=script&lang=js"
export * from "./SustentabilitySection.vue?vue&type=script&lang=js"
import style0 from "./SustentabilitySection.vue?vue&type=style&index=0&id=5490df68&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490df68",
  null
  
)

export default component.exports